/**
 * L9 wild masters (ยอดฝีมือพเนจรป่า): rare humanoids roaming a region's monster pockets and roads, fought by duel rules
 * (guard, guard break, wind-ups: the rival's brain and the arena build body). Each has a real art, an original name and
 * title. Data only; the rules are in systems/wildMasters.ts.
 */
import type { RegionId } from './regions';

export interface WildMasterDef {
  readonly id: string;
  readonly region: RegionId;
  readonly name: string;
  readonly title: string;
  /** A martial art id in data/skills.ts (not hidden, not legendary). */
  readonly art: string;
  readonly neigong: string;
  readonly sprite: string;
  readonly skillLevel: number;
  readonly neigongLevel: number;
}

export const WILD_MASTERS: readonly WildMasterDef[] = [
  { id: 'wm-centre-1', region: 'centre', name: 'ลุงหลวี่ ผู้เดินทุ่ง', title: 'ฝ่ามือไร้ชื่อ', art: 'hum-palm', neigong: 'bell-body', sprite: 'monk', skillLevel: 4, neigongLevel: 4 },
  { id: 'wm-centre-2', region: 'centre', name: 'เจียงหมิ่น ดาบฤดูใบไม้ผลิ', title: 'ดาบพเนจร', art: 'quick-draw-sabre', neigong: 'ember-heart', sprite: 'guardOfficer', skillLevel: 4, neigongLevel: 4 },
  { id: 'wm-north-1', region: 'north', name: 'ฉินเหอ ผู้ฝ่าหิมะ', title: 'กระบี่จันทร์เหมันต์', art: 'listening-blade', neigong: 'mourning-heart', sprite: 'lilac', skillLevel: 5, neigongLevel: 5 },
  { id: 'wm-north-2', region: 'north', name: 'เสวียนจื่อ ฤๅษีสนขาว', title: 'ผู้หลีกโลก', art: 'one-cut', neigong: 'mist-breath', sprite: 'taoist', skillLevel: 5, neigongLevel: 5 },
  { id: 'wm-west-1', region: 'west', name: 'ฟางสุ่ย เรือพเนจร', title: 'ฝ่าหมอกริมน้ำ', art: 'pulse-seal', neigong: 'cloud-heart', sprite: 'taoist', skillLevel: 4, neigongLevel: 4 },
  { id: 'wm-west-2', region: 'west', name: 'หลิวเหยียน นางรำคลื่น', title: 'ร่ายรำเชือดลม', art: 'chorus', neigong: 'mourning-heart', sprite: 'lilac', skillLevel: 4, neigongLevel: 4 },
  { id: 'wm-east-1', region: 'east', name: 'ซาเหอ ผู้ฝ่าทรายเลือด', title: 'กรงเล็บชาด', art: 'tongs-claw', neigong: 'ember-heart', sprite: 'guardOfficer', skillLevel: 5, neigongLevel: 5 },
  { id: 'wm-east-2', region: 'east', name: 'จวี๋หยาง ดาบหน้าผาแดง', title: 'ดาบทะเลทราย', art: 'cliff-push-sabre', neigong: 'ember-heart', sprite: 'monk', skillLevel: 5, neigongLevel: 5 },
  { id: 'wm-south-1', region: 'south', name: 'เมิ่งหลิน ผู้เฝ้าโคมป่า', title: 'มือจับกุมเงา', art: 'chain-hold', neigong: 'ember-heart', sprite: 'guardOfficer', skillLevel: 4, neigongLevel: 4 },
  { id: 'wm-south-2', region: 'south', name: 'หยุนซา เงาดาบมาร', title: 'พเนจรเงามืด', art: 'founder-sabre', neigong: 'bell-body', sprite: 'monk', skillLevel: 5, neigongLevel: 5 },
];

export const WILD_MASTER = {
  /** Seconds of World time per spawn roll window (about 1 per region per hour). */
  hourS: 3600,
  /** Chance a window actually spawns one (1 = one per hour). */
  perHour: 1,
  /** Region-time tries to find a free spot outside a safe zone. */
  tries: 40,
  /** Qi pool and silver on a win, plus the mark. */
  qi: 300,
  silver: 400,
  /** Move levels one mark adds to every move of its art (capped at MAX_SKILL_LEVEL). */
  markLevels: 1,
  tag: 'ยอดฝีมือพเนจร',
} as const;
